import React, { createContext, useState, useRef, useContext  } from 'react';
import { InactivityModal } from '../../components/modals/inactivityModal';
import { AuthService } from '../../services/auth/auth.service';
import { IdleTimerProvider } from 'react-idle-timer';
import { returnToSignin} from '../../utils/returnToSign';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from "../../context/Auth/AuthContext";

const InactivityContext = createContext();

const InactivityProvider = ({ children }) => {

    const [showModal, setShowModal] = useState(false);
    const [countdown, setCountdown] = useState(180); // 3 minutos en segundos
    const countdownRef = useRef(null);
    const { updateAlertSignIn } = useContext(AuthContext);

    const navigate = useNavigate();

    const onIdle = () => {
        setShowModal(true);
        startCountdown();
    };


    const handleModalClose = () => {
        resetTimer();
    };


    const startCountdown = () => {
        countdownRef.current = setInterval(() => {
            setCountdown(prev => {
                if (prev <= 1) {
                    clearInterval(countdownRef.current);

                    //cerrar sesión logout y enviar a login
                    AuthService.logout(
                        {
                            documento: localStorage.getItem('doc'),
                            otp: localStorage.getItem('token')
                        }
                    )
                        .then(() => {
                            console.log('Logout Exitoso...');
                            updateAlertSignIn({
                                message: "Su sesión ha sido expirada, por favor inicie sesión nuevamente.",
                                show: true,
                                title: "Sesión expirada"
                            })
                            returnToSignin(navigate);
                            return 0; 
                        })
                        .catch(e => console.log(e));
                }
                return prev - 1;
            });
        }, 1000);
    };

    const resetTimer = () => {
        setShowModal(false);
        setCountdown(180);
        clearInterval(countdownRef.current);
    };

    return (
        <IdleTimerProvider
            timeout={300000} // 5 minutos
            onIdle={onIdle}
            debounce={250}
        >
            <InactivityContext.Provider value={{resetTimer}}>
                {children}
                <InactivityModal
                    isOpen={showModal}
                    title={`¿Sigues ahí?`}
                    messageTitle={`Tu sesión se cerrará en ${Math.floor(countdown / 60)}: ${countdown % 60 < 10 ? "0" + countdown % 60 : countdown % 60}`}
                    msgPrimary={`Sigo Aquí!`}
                    action={handleModalClose}
                    onHide={() => { }}
                />
            </InactivityContext.Provider>
        </IdleTimerProvider>
    );
};

export { InactivityProvider, InactivityContext };